/**
 * RAC MAIN POPUP CONTAINIER
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { bindActionCreators } from 'redux';
import {
  hidePopUp, getNewNum, getPrimaryNum, doRACSubmit,
} from '../actions/action-rac';
import l10n from '../../lib/reactPPl10nHelper';
import i18n from '../../lib/reacti18n';
import contentHelper from '../../lib/contentHelper';
import { trackLink } from '../../lib/analytics-helper';
import { formatAsTyped, validatePhoneNumber } from '../../lib/date-helper';
import { RAC } from '../constants/PropTypesShapes';
import Page from '../../lib/page';

const label = {
  letUs: l10n.getContent('smarthelp/callUs.call.rac.letUs'),
  experiencing: l10n.getContent('smarthelp/callUs.call.rac.experiencing'),
  willCallYouAboutEwt_one: i18n.message('smarthelp/callUs.call.rac.willCallYouAboutEwt_one'),
  willCallYouAboutEwt_other: i18n.message('smarthelp/callUs.call.rac.willCallYouAboutEwt_other'),
  consent: l10n.getContent('smarthelp/callUs.call.rac.consent'),
  willCallYou: l10n.getContent('smarthelp/callUs.call.rac.willCallYou'),
  changePhone: l10n.getContent('smarthelp/callUs.call.rac.changePhone'),
  enterPhone: l10n.getContent('smarthelp/callUs.call.rac.enterPhone'),
  pleaseCheck: l10n.getContent('smarthelp/callUs.call.rac.pleaseCheck'),
  phoneOnFile: l10n.getContent('smarthelp/callUs.call.rac.phoneOnFile'),
  cancel: l10n.getContent('smarthelp/callUs.call.rac.cancel'),
  racButton: l10n.getContent('smarthelp/callUs.call.rac.racButton'),
};

class RACMainPopUp extends Component {
  static getInputClassNames(inputColorClass) {
    return classNames({
      errorRacInput: inputColorClass === 'redIt',
      successRacInput: inputColorClass === 'greenIt',
    });
  }

  constructor(props) {
    super(props);
    this.state = {
      newElement: '',
      validationError: false,
      inputColorClass: '',
    };
    this.inputValidation = this.inputValidation.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();
    // if primary pick phoneNumber else take form input
    const finalRac = this.props.rac.isPrimary ? this.props.rac.phoneNum : this.state.newElement;
    if (!(this.props.rac.isPrimary)) {
      // custom phone number
      // todo: check validity of number here based on that if error make it red else make it green and submit
      const validity = validatePhoneNumber(this.props.rac.countryCode, finalRac.replace(/\D/g, ''));
      if (validity.errors) {
        this.setState({ validationError: true, inputColorClass: 'redIt' });
      } else {
        this.setState({ validationError: false, inputColorClass: 'greenIt' });
        this.props.doRACSubmit(this.props.rac.countryCode, finalRac, this.props.rac.segment_name);
      }
    } else {
      // primary number
      this.props.doRACSubmit(this.props.rac.countryCode, finalRac, this.props.rac.segment_name);
    }
  }

  popUpHeader() {
    return (
      <div className="popUpHeader">
        <button
          id="racClose"
          className="racClose"
          aria-label="close"
          onClick={() => {
            trackLink({ id: 'requestACall', link: 'racClose' });
            this.props.hidePopUp();
          }}
        >
          &times;
        </button>
        <div className="racLogo">
          <div className="racPPicon" />
        </div>
      </div>
    );
  }

  primaryNumSection() {
    return (
      <div className="mid-primary-num">
        <div className="vx_text-body primeNumberLiner">
          {label.willCallYou}
&nbsp;
          <span>{this.props.rac.formattedPhoneNum}</span>
        </div>
        <div className="changePhoneLink">
          <button
            className="switchNumberStyle"
            onClick={() => {
              trackLink({ id: 'requestACall', link: 'changeNum' });
              this.props.getNewNum();
            }}
          >
            {label.changePhone}
          </button>
        </div>
      </div>
    );
  }

  inputValidation(e) {
    // vnode.attrs.dispatch(inputValidation(e));
    // Strip all characters from the input except digits
    let input = e.target.value;
    input = input.replace(/\D/g, ''); // max 50 numbers
    input = formatAsTyped(input);
    // eslint-disable-next-line no-empty
    if (input.length > 50) {
      input = input.substring(0, 50);
    }
    // what if we enter more than 50 numbers answer- validate helps while submitting
    this.setState({ newElement: input });
  }

  newNumSection() {
    // FPTI for change number RAC click in main popup
    // const autoFocus = (this.state.inputColorClass === 'redIt') ? 'autofocus' : '';
    const validationErrorMsg = (this.state.validationError) ? <div className="showErrorRac" id="racErrorMessage">{label.pleaseCheck}</div> : '';
    return (
      <div className="mid-new-num">
        <label htmlFor="racNumId" id="racPhoneNumberInput" className="accessAid">{label.enterPhone}</label>
        <input
          type="text"
          className={`racInput racMobInput ${RACMainPopUp.getInputClassNames(this.state.inputColorClass)}`}
          id="racNumId"
          placeholder={label.enterPhone}
          autoFocus="true"
          value={this.state.newElement}
          aria-describedby={(this.state.inputColorClass === 'redIt') ? 'racErrorMessage' : ''}
          aria-invalid={(this.state.inputColorClass === 'redIt') ? 'true' : ''}
          onChange={(e) => this.inputValidation(e)}
        />
        { validationErrorMsg }
        <div className="changePhoneLink">
          <button
            className="switchNumberStyle"
            onClick={() => {
              trackLink({ id: 'requestACall', link: 'racChangeNum|primary' });
              this.props.getPrimaryNum();
            }}
          >
            {label.phoneOnFile}
          </button>
        </div>
      </div>
    );
  }

  midSection() {
    return (
      <div className="midSection">
        {this.props.rac.isPrimary && this.primaryNumSection()}
        {!(this.props.rac.isPrimary) && this.newNumSection()}
      </div>
    );
  }

  buttonSection() {
    return (
      <div className="buttonSection vx_btn-group">
        <input
          type="submit"
          id="racSubmitButton"
          className="vx_btn vx_btn-primary racButton"
          value={label.racButton}
        />
        <button
          className="vx_btn vx_btn-secondary racButton racCancelButton"
          id="racCancelButton"
          onClick={() => {
            trackLink({ id: 'requestACall', link: 'racCancel' });
            this.props.hidePopUp();
          }}
          onBlur={() => {
            document.getElementById('racClose').focus(); // todo: onblur change localstate "blurClose" & based on that focus close button
          }}
        >
          {label.cancel}
        </button>
        <button className="racSafeButton" />
      </div>
    );
  }

  mainHeader() {
    const griffinwillCallYouAboutEwt = this.props.rac.ewt === 1 ? 'willCallYouAboutEwt_one' : 'willCallYouAboutEwt_other';
    const willCallYou = contentHelper(label[griffinwillCallYouAboutEwt], { ewt: this.props.rac.ewt });
    return (
      <div className="racBody racBodyMob">
        <div className="titleLiner">
          <h2 className="vx_text-2 racTitleMessage mobTitle" id="rac_popup_title">{label.letUs}</h2>
        </div>
        <div className="headLiner">
          <div className="vx_text-body">
            {label.experiencing}
            <br />
            {Page.getHTMLElement({ message: willCallYou, useHTML: true })}
          </div>
        </div>
        <form className="form-part" onSubmit={this.handleSubmit}>
          {this.midSection()}
          <div className="footLiner">
            <span className="vx_text-body_secondary">
              {Page.getHTMLElement({ message: label.consent, useHTML: true })}
            </span>
          </div>
          {this.buttonSection()}
        </form>
      </div>
    );
  }

  render() {
    return (
      <div className="racPopUpContainer">
        {/* eslint-disable-next-line jsx-a11y/aria-props */}
        <div
          id="rac-popUp"
          tabIndex="-1"
          role="dialog"
          className="racModal sanitizer"
          aria-describedby="rac_popup_title"
        >
          {this.popUpHeader()}
          {this.mainHeader()}
        </div>
      </div>
    );
  }
}

RACMainPopUp.propTypes = {
  rac: PropTypes.shape(RAC).isRequired,
  hidePopUp: PropTypes.func.isRequired,
  getNewNum: PropTypes.func.isRequired,
  getPrimaryNum: PropTypes.func.isRequired,
  doRACSubmit: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    rac: state.rac,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    hidePopUp, getNewNum, getPrimaryNum, doRACSubmit,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(RACMainPopUp);
